import { SxProps, Theme } from '@mui/system';

const styles = {
  headerContainer: {
    mb: 2,
  },
  titleFont: {
    fontSize: 18,
    fontWeight: 600,
  },
  breakdownContainer: {
    px: 3,
    pb: 3,
    pt: 2,
    minWidth: 360,
  },
  breakdownRow: {
    mb: 1.5,
  },
  breakdownLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: 'grey.800',
  },
  breakdownValue: {
    fontSize: 14,
    color: 'grey.900',
    wordBreak: 'break-word',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
